import angular from 'angular';
import AutocompleteWizardSearchComponent from './autocomplete-wizard-search.component';

const autocompleteWizardSearch = angular
	.module('autocompleteWizardSearch', [])
	.component('autocompleteWizardSearch', AutocompleteWizardSearchComponent)
	.name;

export default autocompleteWizardSearch;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/autocomplete-wizard-search/autocomplete-wizard-search.module.js